export const getFullname = (firstName: string, lastName: string) => `${firstName} ${lastName}`;
